import axios from 'axios';
import Account from './main-views/Account';
import MySubscription from './views/MySubscription';
import BuySubscriptionPackage from './views/BuySubscriptionPackage'
import Logo from './ones/Logo';
import { STR_ACCOUNT, STR_CHARITY, STR_CONTACTS, STR_DEBTS, STR_EXPENSES, STR_INCOME, STR_INSURANCE, STR_INTEGRATED_APPS, STR_INVESTMENTS, STR_LEARN, STR_NOTIFICATIONS, STR_SAVINGS } from './Strings';

import { MdChevronLeft } from 'react-icons/md';
import PersonalInfoUpdater from './views/PersonalInfoUpdater';
import ContactUs from './views/ContactUs';
import ReportProblem from './views/ReportProblem';
import LoginView from './views/LoginView';
import Notifications from './main-views/Notifications';
import Messages from './main-views/Messages';
import Contacts from './main-views/Contacts';
import CreateContact from './views/CreateContact';
import ContactOptions from './views/ContactOptions';
import ContactGroupOptions from './views/ContactGroupOptions';
import CreateContactGroup from './views/CreateContactGroup';
import CreateMessage from './views/CreateMessage';
import ViewMessage from './views/ViewMessage';
import WhatsAppSetup from './views/WhatsAppSetup';
import RequestSenderId from './views/RequestSenderId';
import SenderIdRequestOptions from './views/SenderIdRequestOptions';
import IntegratedApps from './main-views/IntegratedApps';
import IntegrateMauzoCrm from './views/IntegrateMauzoCrm';

export const BASE_API = 'https://bulkapi.werenium.com/api/';

export const CDN_URL = 'https://werenium.com/ssid/cdn/'


export function getMainView(app) {
  if (app.navItem === 'messages' || !app.navItem) {
    return <Messages />;
  } else if (app.navItem === 'account') {
    return <Account />;
  } else if (app.navItem === 'contacts') {
    return <Contacts />;
  } else if (app.navItem === 'notifications') {
    return <Notifications />;
  } else if (app.navItem === 'integrated-apps') {
    return <IntegratedApps />;
  } else if(app.navItem === 'ref' && app.navSubItem) {
    app.setReferrerUid(app.navSubItem);
    return <Messages />;
  }

  return null;
}


export function getViewerView(app) {
  if (
    app.navSubItem === 'my-subscription' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <MySubscription />;
  } else if (
    app.navSubItem === 'personal_info_updater' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <PersonalInfoUpdater />;
  } else if (
    app.navSubItem === 'contact_us' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ContactUs />;
  } else if (
    app.navSubItem === 'report-problem' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ReportProblem />;
  } else if (
    app.navSubItem === 'whatsapp-setup' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <WhatsAppSetup />;
  } else if (
    app.navSubItem === 'login' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <LoginView />;
  } else if (
    app.navSubItem === 'create-contact' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <CreateContact />;
  } else if (
    app.navSubItem === 'create-contact-group' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <CreateContactGroup />;
  } else if (
    app.navSubItem === 'create-message' &&
    (!app.navExtraItem || app.navExtraItem) &&
    (!app.navMoreItem || app.navMoreItem)
  ) {
    return <CreateMessage appType={app.navExtraItem} accountId={app.navMoreItem} />;
  } else if (
    app.navSubItem === 'message' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ViewMessage id={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'request-sender-id' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <RequestSenderId />;
  } else if (
    app.navSubItem === 'integrate-mauzo-crm' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <IntegrateMauzoCrm />;
  }


  return null;
}

export function getSideViewerView(app) {
  if (
    app.navSubItem === 'contact-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ContactOptions id={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'contact-group-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ContactGroupOptions id={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'sender-id-request-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <SenderIdRequestOptions id={app.navExtraItem} />;
  }

  return null;
}

export function getBottomViewerView(app) {

  if (
    app.navSubItem === 'buy-subscription-package' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <BuySubscriptionPackage />;
  }

  return null;
}

export function getTopBarTitle(app) {
  if ((!app.navItem || app.navItem === 'messages') && !app.navSubItem) {
    return <Logo />
  } else if (app.navItem === 'contacts' && (!app.navSubItem || app.navSubItem)) {
    return <h6 className='mTopBarTitle'><MdChevronLeft className='mNoMargin mNoPadding' onClick={app.navBack} size={40} /> {STR_CONTACTS[app.language]}</h6>;
  } else if (app.navItem === 'account' && !app.navSubItem) {
    return <h6 className='mTopBarTitle'><MdChevronLeft className='mNoMargin mNoPadding' onClick={app.navBack} size={40} /> {STR_ACCOUNT[app.language]}</h6>;
  } else if (app.navItem === 'notifications' && !app.navSubItem) {
    return <h6 className='mTopBarTitle'><MdChevronLeft className='mNoMargin mNoPadding' onClick={app.navBack} size={40} /> {STR_NOTIFICATIONS[app.language]}</h6>;
  } else if (app.navItem === 'account' && app.navSubItem === 'sender-ids') {
    return <h6 className='mTopBarTitle'><MdChevronLeft className='mNoMargin mNoPadding' onClick={app.navBack} size={40} /> Sender IDs</h6>;
  } else if (app.navItem === 'integrated-apps' && !app.navSubItem) {
    return <h6 className='mTopBarTitle'><MdChevronLeft className='mNoMargin mNoPadding' onClick={app.navBack} size={40} />{STR_INTEGRATED_APPS[app.language]}</h6>;
  } else if (app.navItem === 'integrated-apps' && app.navSubItem === 'mauzocrm') {
    return <h6 className='mTopBarTitle'><MdChevronLeft className='mNoMargin mNoPadding' onClick={app.navBack} size={40} />Mauzo CRM</h6>;
  }

  return null;
}


export function getInlineLoader() {
  return (
    <div className="Loader"></div>
  )
}

export function remove255(input) {
  if (input.startsWith('255')) {
    return '0' + input.slice(3);
  }
  return input;
}

export function formatDate(timestamp, fromPhp = true) {
  timestamp = (fromPhp) ? Number(timestamp) * 1000 : timestamp;
  let date = new Date(timestamp);
  return (date.toLocaleString());
}

export function formatDateForInput(timestamp) {
  // Convert timestamp from seconds to milliseconds
  const date = new Date(timestamp * 1000);

  // Extract year, month, and day with padding for month and day if needed
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');

  // Format the date as YYYY-MM-DD for input type="date"
  return `${year}-${month}-${day}`;
}

export function isSameWeek(date) {
  const today = new Date();
  const currentWeekDay = today.getDay();
  const firstDayOfWeek = new Date(today.setDate(today.getDate() - currentWeekDay)); // Sunday
  const lastDayOfWeek = new Date(today.setDate(today.getDate() + 6)); // Saturday

  return date >= firstDayOfWeek && date <= lastDayOfWeek;
};

export function isSameMonth(date) {
  const today = new Date();
  return date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
};

export function callApi(url, params) {
  return new Promise(async resolve => {
    await getLocalUser().then(user => {
      //..
      //call main api
      let formData = new FormData();

      //append lnguage
      formData.append('language', getCookie('language'));

      for (let key in params) {
        formData.append(key, params[key]);
      }

      for (let key in user) {
        formData.append(key, user[key]);
      }

      axios.post(BASE_API + url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then(response => {

        console.log(url, response.data);

        resolve(response.data);
      }).catch(error => {
        resolve({
          status: 0,
          msg: "Network Connection Error",
        })
      })
      //..
    })

  })
}

export function getLocalUser() {
  return new Promise(async resolve => {
    //use cookies
    let userId = getCookie('kumbuka-userId');
    let userToken = getCookie('kumbuka-userToken');
    let userType = getCookie('kumbuka-userType');

    resolve({
      userId,
      userToken,
      userType,
    })


  })
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();

  // Get the current domain from window.location.hostname
  let domain = window.location.hostname;

  // Set domainPart only if it's not 'localhost'
  let domainPart = domain !== 'localhost' ? `;domain=${domain}` : '';

  // Add the SameSite attribute to restrict cross-origin access (Strict or Lax as per your needs)
  let sameSite = ";SameSite=Strict";

  // Add the Secure flag for HTTPS connections
  let secureFlag = window.location.protocol === 'https:' ? ";Secure" : '';

  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/" + domainPart + sameSite + secureFlag;
}


export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


export function formatMoney(x) {
  x = Number(x);

  // Check if the number has a decimal part
  let hasDecimal = x % 1 !== 0;

  // Format based on whether there's a decimal
  x = hasDecimal ? x.toFixed(2) : x.toString();

  // Split into integer and decimal parts
  var parts = x.split(".");

  // Add comma separation to the integer part
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Return the formatted number, with decimals only if present
  return parts.join(".");
}

export function formatMoneyShorten(num, digits = 2) {
  num = Number.parseFloat(num);
  if (num <= 1 && num >= -1) {
    return num;
  }

  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup.slice().reverse().find(function (item) {
    return Math.abs(num) >= item.value; // Use absolute value of num
  });
  return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

export function strtotime(dateString) {
  const date = new Date(dateString);

  // Check if time part is missing in the date string
  if (dateString.trim().length <= 10) { // If length is 10, it's just 'YYYY-MM-DD'
    date.setHours(23, 59, 59, 999); // Set time to the end of the day (23:59:59.999)
  }

  return Math.floor(date.getTime() / 1000);
}
